import { put, select, takeLatest } from 'redux-saga/effects'

import { teams as teamActions } from '../constants/actions'
import { files, teams } from '../constants/endpoints'
import { getEventId, getOrganisationId, getUser, getUserId } from '../selectors'
import { get, post } from '../utils/request'

function* getTeamsByCode({ payload }) {
  const eventId = yield select(getEventId)

  const response = yield get({
    endpointId: teams.getTeamsByCode,
    params: { teamCode: payload, eventId },
  })

  if (response.data) {
    yield put(teamActions.setTeamsByCode(response.data))
  }
}

function* getTeamsByUser() {
  const { userid, email } = yield select(getUser)
  const response = yield get({
    endpointId: teams.getTeamsByUser,
    params: {
      userid,
      loggedInUser: email,
    },
  })

  if (response.data) {
    yield put(teamActions.setTeamsByUser(response.data))
  }
}

function* getAllTeamCodes() {
  const response = yield get({
    endpointId: teams.getAllTeamCodes,
  })

  if (response.data) {
    yield put(teamActions.setAllTeamCodes(response.data))
  }
}

export function* sendEmailTeamRego({ payload }) {
  const { teamDetails, teamCode } = payload.teamData
  const { logo: teamLogo, teamEmail, teamName, teamMobile = {}, teamPrimaryContact } = teamDetails
  const loggedInUser = yield select(getUserId)
  const organisationId = yield select(getOrganisationId)
  const eventId = yield select(getEventId)

  const response = yield post({
    endpointId: teams.sendEmailTeamRego,
    data: {
      teamData: {
        teamName,
        teamManagerName: teamPrimaryContact,
        teamCode,
        teamLogo,
        eventId,
        teamContact: teamPrimaryContact,
        teamPhoneNumber: teamMobile.value,
        teamEmail,
      },
      loggedInUser,
      organisationId,
      recipients: payload.recipients,
    },
  })

  if (response) {
    yield put(teamActions.setAllTeamCodes(response.data))
  }
}

function* getTeamsInEvent() {
  const eventId = yield select(getEventId)
  const response = yield get({
    endpointId: teams.getTeamsInEvent,
    params: { eventId },
  })

  if (response.data) {
    yield put(teamActions.setTeamsInEvent(response.data.rows))
  }
}

function* getTeamLogo({ payload }) {
  const image = yield get({
    endpointId: files.download,
    params: {
      key: payload,
      isImage: true,
    },
  })
  yield put(teamActions.setTeamLogo(image.data ? image.data : undefined))
}

export function* runTeamsSagas() {
  yield takeLatest(teamActions.GET_TEAMS_BY_CODE, getTeamsByCode)
  yield takeLatest(teamActions.GET_TEAMS_BY_USER, getTeamsByUser)
  yield takeLatest(teamActions.GET_ALL_TEAM_CODES, getAllTeamCodes)
  yield takeLatest(teamActions.SEND_EMAIL_TEAM_REGO, sendEmailTeamRego)
  yield takeLatest(teamActions.GET_TEAMS_IN_EVENT, getTeamsInEvent)
  yield takeLatest(teamActions.GET_TEAM_LOGO, getTeamLogo)
}
